import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
  selector: 'app-custom-site-admin-edit-page',
  templateUrl: 'custom-site-admin-edit.page.html',
  styleUrls: [
    './custom-site-admin-edit.page.scss',
  ]
})
export class CustomSiteAdminEditPage {
  webReport:any={};
  loading:boolean=true ;
  id:number;
  categories:any[];
  shortName:string;
  webReportUsers= [
  { name: 'John', phone: '123', email: 'a@b.com' },
];
  selectedCategory:string;
  categoryInput:string;
    constructor(
        private systemSettingService: SystemSettingService,
              private route: ActivatedRoute,
            private toasterService: ToasterService,
      ) { 
  
    }
 ngOnInit() {
  this.loadData();
   
  }
  async loadData() {
    this.loading=false;
    this.id=Number(this.route.snapshot.paramMap.get('id'));
    await this.systemSettingService.getCustomSiteReportById(this.id).then((res) => {
    this.webReport = res.webReport || res;
    this.categories = res.categories;
    this.webReportUsers=res.webReportUsers;
      });
      this.loading=true;
    }
  toggleSelection(setting: any, event: any) {
    setting.data = event.detail.checked;
  }

async saveWebReport(){
  
  this.loading=false;
 if (!this.webReport) return;

  const missingFields = [];

  if (!this.webReport.shortName?.trim()) missingFields.push("Short Name");
  if (!this.webReport.reportType?.trim()) missingFields.push("Report Type");
  if (!this.webReport.accessLevel?.trim()) missingFields.push("Access Level");
  if (!this.webReport.apP_TARGET?.trim()) missingFields.push("Target");
  if (!this.webReport.description?.trim()) missingFields.push("Description");

  if (!this.webReport.category?.trim()) {
    missingFields.push("Category");
  } else if (this.webReport.category === "new" && !this.categoryInput?.trim()) {
    missingFields.push("New Category Name");
  }


  if (missingFields.length > 0) {
    this.toasterService.presentToast(
          "danger",
          "Please fill the following fields :" + missingFields.join(", "),
          "Error"
        );
    this.loading=true;
    return;
  }
  if(this.categoryInput!=null){
      this.webReport.category=this.categoryInput;
  }
  await  this.systemSettingService.saveCustomSiteAdmin(this.webReport).then((response) => {
      if (response === 'success') {
        this.toasterService.presentToast(
          "primary",
          "The Custom site were updated.",
          "Success"
        );

      } else {
        this.toasterService.presentToast(
          "danger",
          `Error adding custom site admin.`,
          "Error"
        );
        this.loading=true;
        return false;
      }
    });
    this.loading=true;
  }
onCategoryChange(){

}
}